import React from 'react';

const NoMatch = (props) => {
	props.history.push('/');
	return <div>404</div>;
};

export default NoMatch;
